import { MonthAvailability } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export const getMonthAvailableFromDateLabel = (
  monthAvailableOn: MonthAvailability
): string => {
  switch (monthAvailableOn) {
    case MonthAvailability.WITHIN_DATE_RANGE:
    case MonthAvailability.EVERY_DAY:
      return 'From';
    case MonthAvailability.ON_SPECIFIC_DAY:
    default:
      return 'Date';
  }
};
